import React, { useEffect, useState } from "react";
import { Table, Card, Badge } from "react-bootstrap";
import { FaBook } from "react-icons/fa";
import Pagination from "../../components/Pagination";

function AttendanceList() {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");

  const [attendance, setAttendance] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const perPage = 10;

  useEffect(() => {
    fetchAttendanceList(currentPage);
  }, [currentPage, user_id]);

  useEffect(() => {
    const totalPages = Math.max(1, Math.ceil(totalRecords / perPage));
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalRecords]);

  const fetchAttendanceList = async (page = 1) => {
    if (!user_id) return;
    setLoading(true);
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/attendance-list?page=${page}&limit=${perPage}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ user_id: user_id }),
        }
      );

      if (!res.ok) throw new Error("Failed to fetch attendance list");

      const payload = await res.json();
      setAttendance(payload.data || []);
      setTotalRecords(payload.total || 0);
    } catch (err) {
      console.error("Error fetching attendance:", err);
      setAttendance([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  const formatDateTime = (dateTimeString) => {
    try {
      return new Date(dateTimeString).toLocaleString("en-IN", {
        dateStyle: "medium",
        timeStyle: "short",
      });
    } catch (error) {
      return "Invalid date";
    }
  };

  const getStatusBadge = (status = "") => {
    const s = String(status).toLowerCase();
    if (s === "ongoing") return <Badge bg="success">Ongoing</Badge>;
    if (s === "completed") return <Badge bg="primary">Completed</Badge>;
    return <Badge bg="secondary">{status}</Badge>;
  };

  const renderPagination = () => {
    const totalPages = Math.ceil(totalRecords / perPage);
    if (!totalPages || totalPages <= 1) return null;

    const pages = [];

    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      pages.push(1);

      if (currentPage > 4) pages.push("left-ellipsis");

      const start = Math.max(2, currentPage - 2);
      const end = Math.min(totalPages - 1, currentPage + 2);
      for (let i = start; i <= end; i++) pages.push(i);

      if (currentPage < totalPages - 3) pages.push("right-ellipsis");
      pages.push(totalPages);
    }

    return (
      <Pagination className="mt-3">
        <Pagination.Prev
          onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {pages.map((p, idx) => {
          if (p === "left-ellipsis" || p === "right-ellipsis") {
            return <Pagination.Ellipsis key={`ell-${idx}`} disabled />;
          }
          return (
            <Pagination.Item
              key={p}
              active={p === currentPage}
              onClick={() => {
                if (p !== currentPage) setCurrentPage(p);
              }}
            >
              {p}
            </Pagination.Item>
          );
        })}
        <Pagination.Next
          onClick={() =>
            currentPage < Math.ceil(totalRecords / perPage) &&
            setCurrentPage(currentPage + 1)
          }
          disabled={currentPage >= Math.ceil(totalRecords / perPage)}
        />
      </Pagination>
    );
  };

  return (
    <Card className="shadow border-0">
      <Card.Header className="bg-primary text-white fw-semibold">
        <FaBook className="me-2" />
        Attendance List
      </Card.Header>
      <Card.Body>
        {loading ? ( 
          <p>Loading...</p>
        ) : attendance.length === 0 ? (
          <p>No records found</p>
        ) : (
          <>
            <Table striped bordered hover responsive>
              <thead className="table-success">
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Meeting Name</th>
                  <th>Date & Time</th>
                  {/* <th>Status</th> */}
                </tr>
              </thead>
              <tbody>
                {attendance.map((row, index) => (
                  <tr key={row.id}>
                    <td>{index + 1}</td>
                    <td>{row.username}</td>
                    <td>{row.title}</td>
                    <td>{formatDateTime(row.date_time)}</td>
                    {/* <td>{getStatusBadge(row.status)}</td> */}
                  </tr>
                ))}
              </tbody>
            </Table>

            {totalRecords > perPage && renderPagination()}
          </>
        )}
      </Card.Body>
    </Card>
  );
}

export default AttendanceList;
